<template>
    <!-- Este componente es el que muestra los siniestros del especialista en el dashboard -->
    <div id="specialist-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <upload-invoice
                v-if="modalUploadInvoice"
                :role_id="role_id"
                :reg_id="supplier_id"
                :type_invoice="type_invoice"
                :is_sinister="true"
                :selected_rows="savedSelectedRows"
                v-on:close="showModal=false">
            </upload-invoice>

            <complement-invoice
                :role_id="role_id"
                :invoice_array="savedSelectedRows"
                :invoice_id="invoice_id_row"
                :supplier_id="supplier_id"
                v-if="complementInvoice"/>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row">
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                      v-model="pagination.current_page" :total-rows="pagination.total"
                                      :per-page="pagination.per_page" aria-controls="my-table"
                                      v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                        <select id="sinister_status_paid" class="float" v-model="params.status"
                                v-on:change="filterStatusSinister()">
                            <option :value="null">Todas</option>
                            <option :value="0">Sin Facturar</option>
                            <option :value="1">Pagadas</option>
                        </select>
                    </div>
                    <div class="col-12 col-xl-4 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                               placeholder="Buscar por palabra">
                        <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <button class="formSubmit" v-if="savedSelectedRows.length>0 && !showComplementColumn"
                                @click="updateAction(1)">
                            Subir Factura
                        </button>
                        <button class="formSubmit" v-if="savedSelectedRows.length>0 && !showFacturarColumn"
                                @click="updateAction(2)">
                            Subir Complemento
                        </button>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <b-table sticky-header="100vh" stacked="md" id="my-table" striped hover :fields="fields"
                             :busy="isBusy" :items="pagination.data" :filter="filter" :select-mode="selectMode"
                             selectable no-select-on-click ref="selectableTable">
                        <template #head(acciones)="{item}">
                            <i class="fa-solid fa-gear"></i>
                        </template>
                        <template v-if="showFacturarColumn" #cell(facturar)="{ rowSelected, index, item }">
                            <button class="badge rounded-pill border-0"
                                    :class="rowSelected?'text-bg-green':'text-bg-orange'"
                                    v-if="item.invoice_id===null && item.paid_at===0"
                                    @click="clickRow(index, item, rowSelected, 'invoice')">
                                <i v-if="!rowSelected" class="fa-regular fa-circle-check"></i>
                                <i v-else class="fa-solid fa-circle-check"></i>
                            </button>
                        </template>
                        <template v-if="showComplementColumn" #cell(complementos)="{ rowSelected, index, item }">
                              <span v-if="item.relinvoice && item.paid_at===1">
                                <button class="badge rounded-pill border-0"
                                        :class="rowSelected?'text-bg-green':'text-bg-gray'"
                                        v-if="item.relinvoice.payment_complement===null && item.paid_at===1"
                                        @click="clickRow(index, item, rowSelected, 'complement')">
                                    <i v-if="!rowSelected" class="fa-regular fa-circle-check"></i>
                                    <i v-else class="fa-solid fa-circle-check"></i>
                                </button>
                              </span>
                        </template>
                        <!-- A virtual column -->
                        <template #cell(paciente)="{item}">
                            <span>{{ item.id }}</span>
                        </template>
                        <template #cell(paciente)="{item}">
                            <span>{{ item.sku }}</span>
                        </template>
                        <template #cell(motivo)="{item}">
                            <span v-if="item.relreason">{{ item.relreason.name }}</span>
                        </template>
                        <template #cell(lugar)="{item}">
                            <span v-if="item.relplace">{{ item.relplace.name }}</span>
                        </template>
                        <template #cell(pdf)="{item}">
                            <span v-if="item.pdf">
                                <a class="fileName badge rounded-pill text-bg-blue"
                                   :href="'../storage/siniestro/'+item.pdf"
                                   target="_blank">
                                    <i class="fas fa-file-pdf"></i>
                                </a>
                            </span>
                        </template>
                        <template #cell(pago)="{item}">
                            <a target="_blank"
                               v-if="item.paid_at===1 && item.relinvoice && item.relinvoice.tickets && item.relinvoice.tickets.length > 0"
                               :href="'/storage/especialistas/tickets/' + supplier_id+'/'+item.relinvoice.tickets[0].ticketImg">
                                <span class="badge rounded-pill text-bg-success">
                                    <i class="fa-solid fa-circle-check"></i>
                                </span>
                            </a>
                            <span v-else class="badge rounded-pill text-bg-orange">
                                <i class="fa-solid fa-circle-exclamation"></i>
                            </span>
                        </template>
                        <template #cell(factura)="{item}">
                            <span v-if="item.relinvoice">
                                <a class="badge rounded-pill text-bg-green"
                                   :href="'/storage/especialistas/facturas/' + supplier_id+'/'+item.relinvoice.factura_name+'.pdf'"
                                   target="_blank">
                                    <i class="fas fa-file-invoice"></i>
                                </a>
                            </span>
                        </template>
                        <template #cell(complemento)="{item}">
                            <span v-if="item.relinvoice">
                                <a v-if="item.relinvoice.payment_complement" class="badge rounded-pill text-bg-green"
                                   :href="'/storage/especialistas/facturas/' + supplier_id+'/complementos/'+item.relinvoice.payment_complement.complement_name+'.pdf'"
                                   target="_blank">
                                    <i class="fas fa-file-invoice"></i>
                                </a>
                            </span>
                        </template>
                        <template #cell(fecha_de_atencion)="{item}">
                            {{ formatDate(item.fecha_atencion) }}
                        </template>
                        <template #cell(acciones)="{item}">
                            <div class="dropdown" v-if="savedSelectedRows.length===0">
                                <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-cogs"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a v-if="theRowSelected && item.paid_at===0" class="dropdown-item"
                                       href="javascript:void(0)"
                                       v-on:click="uploadInvoice(item.id,1);">
                                        Fact. Siniestros
                                    </a>
                                    <a v-if="role_id===4 && item.auth_extra_serv===1"
                                       class="dropdown-item" href="javascript:void(0)"
                                       v-on:click="uploadInvoice(item.id,2);">
                                        Fact. Hon. Extras
                                    </a>
                                </div>
                            </div>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {sinisterService} from "../../Services/Sinister.service";
import {forEach} from "lodash";

export default {
    name: "list-sinister",
    mixins: [myMixins],
    props: {
        supplier_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            invoiceSelectedCount: 0,
            complementSelectedCount: 0,
            showComplementColumn: true,
            model_type_row: '',
            invoice_id_row: 0,
            theRowSelected: false,
            type_invoice: 0,
            showFacturarColumn: true,
            selectMode: 'multi',
            prov_role_id: 0,
            specialist_id: 0,
            inst_id: 0,
            modificar: false,
            isBusy: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            params: {
                limit: 10,
                page: 1,
                status: null,
                where: [],
            },
            fields: [
                {key: 'facturar'},
                {key: 'complementos'},
                {key: 'id'},
                {key: 'paciente'},
                {key: 'motivo'},
                {key: 'lugar'},
                {key: 'pdf'},
                {key: 'pago'},
                {key: 'factura'},
                {key: 'complemento'},
                {key: 'fecha_de_atencion'},
                {key: 'acciones'},
            ],
            specialists: [],
            institutions: [],
            savedSelectedRows: [],
            selectedRows: [],
            providers: [],
            list_providers: [],
            reg_id: 0,
            reg_id_row: 0,
            supplier_id_row: 0,
        }
    },
    methods: {
        clickRow(index, item, rowSelected, type) {
            console.log('clickRow', rowSelected);

            if (rowSelected) {
                this.$refs.selectableTable.unselectRow(index);
                if (type === 'invoice') {
                    this.savedSelectedRows = this.savedSelectedRows.filter(id => id !== item.id);
                } else if (type === 'complement') {
                    this.savedSelectedRows = this.savedSelectedRows.filter(id => id !== item.invoice_id);
                }
                if (this.savedSelectedRows.length === 0) {
                    this.showComplementColumn = true;
                    this.showFacturarColumn = true;
                }
            } else if (item.paid_at === 1 || item.paid_at === 0) {
                //console.log('type', type);
                switch (type) {
                    case 'invoice':
                        this.showComplementColumn = false;
                        break;
                    case 'complement':
                        this.showFacturarColumn = false;
                        break;
                }
                this.$refs.selectableTable.selectRow(index);
                this.onRowSelected(item, type);
            }
        },

        onRowSelected(items, type) {
            //console.log('onRowSelected', items);
            if (type === 'invoice') {
                this.savedSelectedRows.push(items.id);
            } else if (type === 'complement') {
                this.savedSelectedRows.push(items.invoice_id);
            }

            //console.log('savedSelectedRows', this.savedSelectedRows);
        },

        updateAction(e) {
            switch (e) {
                case 1:
                    this.loadInvoice();
                    break;
                case 2:
                    this.loadComplement()
                    break;
            }

        },
        loadInvoice() {
            this.openModalsProviders('upload_invoice')
        },
        loadComplement() {
            this.openModalsProviders('complement_invoice')
        },
        onChange(page) {
            //console.log('onchange');
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        uploadInvoice(id, type_invoice) {
            this.reg_id = id;
            this.type_invoice = type_invoice;
            //console.log('quoting_id', this.quoting_id);
            this.openModalsProviders('invoice_sinister');
        },
        async index() {
            this.isBusy = true;
            this.params.where = [
                {
                    field: 'supplier_id',
                    operator: '=',
                    value: this.supplier_id,
                }, {
                    field: 'model_type',
                    operator: '=',
                    value: 'App\\Models\\' + this.roleModels[this.role_id],
                }
            ];

            //console.log('params', this.params);

            this.pagination = await sinisterService.getMany(this.params);
            this.isBusy = false;
        },
        async filterStatusSinister() {

            this.isBusy = true;
            this.params.where = [
                {
                    field: 'supplier_id',
                    operator: '=',
                    value: this.supplier_id,
                }, {
                    field: 'model_type',
                    operator: '=',
                    value: 'App\\Models\\' + this.roleModels[this.role_id],
                }, {
                    field: 'paid_at',
                    operator: '=',
                    value: this.params.status,
                }
            ];
            this.pagination = await sinisterService.getMany(this.params);
            this.isBusy = false;

        },
    },
    mounted() {
        this.index();
        //console.log('supplier_id', this.supplier_id);
    }
}
</script>

